var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBetaIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 793 333.3",
    style: {
      enableBackground: "new 0 0 793 333.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#2159D1;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M702.6,0H91.5C41,0,0,41,0,91.5v150.9c0,50.2,40.7,90.9,90.9,90.9h611.8c49.8,0,90.3-40.4,90.3-90.3V90.4 C793,40.5,752.5,0,702.6,0z M110,83.4h71.3c38.4,0,58.2,17.4,58.2,43.2c0,19.5-13.2,33.1-32,37.1v1.7c20.7,0.9,38.6,16.4,38.6,41.1 c0,27.6-21.7,47.8-59.5,47.8H110V83.4z M174.2,153.7c13.5,0,23.2-7,23.2-19c0-11.3-8.8-18.4-22.5-18.4h-23.5v37.5H174.2z M176.8,221 c17.9,0,26.2-7.2,26.2-19.3c0-13.1-9.7-21.4-25.5-21.4h-26.3V221H176.8z M259.7,83.4h119.2v33.5H301v35h71.8v33.6H301v35.1h77.9 v33.5H259.7V83.4z M392.8,83.4h144.5v33.5h-51.8v137.4h-40.7V116.9h-51.9V83.4z M522.4,254.3l57.7-170.9h55l57.7,170.9h-44.4 l-11.3-35.9h-59l-11.3,35.9H522.4z M627.2,187l-19-60.6h-1.3L587.9,187H627.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBetaIcon);
export default __webpack_public_path__ + "static/media/beta_icon.2dda8e9b02233f04bbc51e6e949d99ae.svg";
export { ForwardRef as ReactComponent };